import { EVENTS } from '../config'
import { getStatsObject, on, off } from '../controllers/stats'
import { useEffect, useState } from 'react'
import { StatsObject } from '../types'

const useStats = () => {
	const [stats, setStats] = useState<StatsObject>(getStatsObject())

	useEffect(() => {
		function update() {
			setStats(getStatsObject())
		}

		on(EVENTS.STATS_CHANGED, update)
		return () => off(EVENTS.STATS_CHANGED, update)
	}, [])

	return stats
}

export default useStats
